import { Collapse, Spin } from "antd";
import React, { useMemo } from "react";
import HeaderLogoContent from "./HeaderLogoContent";
import styled from "styled-components";
import WelcomeText from "./WelcomeText";
import DescriptionText from "./DescriptionText";
import Rearrangement from "./Rearrangement";
import BannerPage from "./BannerPage";
import {
  getCmsConfigurations,
  updateCmsConfigurations,
  updateMultipleCmsConfigurations,
} from "../../Services/cms_configuration";
import { useMutation, useQuery } from "@tanstack/react-query";
import AppTheme from "./AppTheme";

const StyledLabel = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #363e61;
  margin: 0;
`;

function CMS() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["cms_configuration_list"],
    queryFn: () => getCmsConfigurations(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,
  });

  // Safely transform data.data into a config map
  const cmsConfigMap = useMemo(() => {
    if (!data?.data) return {};

    return data.data.reduce((acc, item) => {
      acc[item.name_slug] = item;
      return acc;
    }, {});
  }, [data]);

  const editMutation = useMutation({
    mutationFn: updateCmsConfigurations,
    onSuccess: () => {
      refetch();
    },
  });

  const editMultipleMutation = useMutation({
    mutationFn: updateMultipleCmsConfigurations,
    onSuccess: () => {
      refetch();
    },
  });

  const handleEdit = (values) => {
    editMutation.mutate({ ...values });
  };

  const handleMultipleEdit = (values) => {
    editMultipleMutation.mutate({ ...values });
  };

  const headerLogo = cmsConfigMap["header_logo"] || {};
  const welcomeText = cmsConfigMap["welcome_text"] || {};
  const descriptionText = cmsConfigMap["home_description"] || {};
  const appTheme = cmsConfigMap["app_theme_color"] || {};
  const homeRearrangement = cmsConfigMap["home_rearrangement"] || {};
  const bannerBgImage = cmsConfigMap["home_banner_image"] || {};
  const bannerBgColor = cmsConfigMap["home_banner_bg_color"] || {};

  const items = [
    {
      key: "1",
      label: <StyledLabel>App Logo</StyledLabel>,
      children: (
        <HeaderLogoContent
          data={headerLogo}
          onUpdate={handleEdit}
          baseURL={data?.base_url}
        />
      ),
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
    {
      key: "2",
      label: <StyledLabel>Welcome Text Content</StyledLabel>,
      children: <WelcomeText data={welcomeText} onUpdate={handleEdit} />,
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
    {
      key: "3",
      label: <StyledLabel>Description Text Content</StyledLabel>,
      children: (
        <DescriptionText data={descriptionText} onUpdate={handleEdit} />
      ),
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
  
    {
      key: "5",
      label: <StyledLabel>Banner </StyledLabel>,
      children: (
        <BannerPage
          bannerBgImage={bannerBgImage}
          bannerBgColor={bannerBgColor}
          baseURL={data?.base_url}
          onMutipleUpdate={handleMultipleEdit}
        />
      ),
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
    {
      key: "6",
      label: <StyledLabel>App Theme </StyledLabel>,
      children: (
        <AppTheme
          data={appTheme?.value_json || []}
          baseData={appTheme}
          onUpdate={handleEdit}
        />
      ),
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
    {
      key: "4",
      label: <StyledLabel>Section Arrangement Order</StyledLabel>,
      children: (
        <Rearrangement
          data={homeRearrangement?.value_json || []}
          onUpdate={handleEdit}
          baseData={homeRearrangement}
        />
      ),
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #848091",
        borderRadius: "10px",
      },
    },
  ];
  return (
    <div>
      <Spin spinning={isLoading || editMutation?.isPending}>
        <Collapse
          bordered={false}
          defaultActiveKey={items?.map((item) => item.key)}
          style={{ background: "#ffffff" }}
          items={items}
          expandIconPosition={"end"}
          collapsible="icon"
        />
      </Spin>
    </div>
  );
}

export default CMS;
